import { createSelector } from 'reselect';

import { AppState } from '../../store/models/app-state';

const unitsState = (state: AppState) => state.units;

export const unitsSelector = createSelector(unitsState, units => units.allUnits);
